<template>
  <a-spin :spinning="spinning">
    <a-form
      ref="formRef"
      :model="form"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      labelAlign="left"
    >
      <a-row :gutter="24">
        <a-col :xs="24" :md="12" :lg="8">
          <a-form-item label="Job ID">
            <a-select v-model:value="form.jobId">
              <a-select-option
                :key="item"
                :value="item"
                v-for="item in jobList"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12" :lg="8">
          <a-form-item label="Create By">
            <span>{{ form.createBy }}</span>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12" :lg="8">
          <a-form-item label="Response By">
            <span>{{ form.responseBy }}</span>
          </a-form-item>
        </a-col>

        <a-col :xs="24" :md="12" :lg="8">
          <a-form-item label="Stop Working">
            <a-switch
              :disabled="currentRow.createOn && currentRow.stopEnd"
              v-model:checked="form.stopWS"
            ></a-switch>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12" :lg="8">
          <a-form-item label="Stop start" v-if="startControl">
            <a-date-picker
              show-time
              format="MM-DD HH:mm"
              :disabled="!currentRow.stopWS && currentRow.stopEnd != null"
              placeholder="Please Select..."
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              v-model:value="form.stopStart"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12" :lg="8">
          <a-form-item label="Stop end" v-if="endControl">
            <a-date-picker
              show-time
              format="MM-DD HH:mm"
              :disabled="!currentRow.stopWS && currentRow.stopEnd != null"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              placeholder="Please Select..."
              v-model:value="form.stopEnd"
            />
          </a-form-item>
        </a-col>

        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 24 }">
            <div class="m-label">Comments:</div>
            <a-textarea v-model:value="form.comments" :rows="5"></a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-spin>
</template>
<script>
  import dayjs from 'dayjs'
  import { message, Modal } from 'ant-design-vue'
  import { responseandon, closeAndon } from '@/api/supervisor-landing'
  export default {
    props: {
      currentRow: {
        type: Object,
        default() {
          return {}
        },
      },
      jobList: {
        type: Array,
        default() {
          return []
        },
      },
    },
    watch: {
      currentRow: {
        handler(v) {
          const currentRow = { ...v }
          currentRow.stopStart = currentRow.stopStart
            ? dayjs(currentRow.stopStart)
            : null
          currentRow.stopEnd = currentRow.stopEnd
            ? dayjs(currentRow.stopEnd)
            : null
          this.form = currentRow
        },
        deep: true,
        immediate: true,
      },
      startControl(v) {
        if (v && !this.form.stopStart) {
          this.form.stopStart = dayjs()
        }
      },
      endControl(v) {
        if (v && !this.form.stopEnd) {
          this.form.stopEnd = dayjs()
        }
      },
    },
    computed: {
      startControl: function () {
        const item = this.form
        const current = { ...this.currentRow }
        return (
          current.stopWS ||
          (!current.stopWS && current.stopEnd !== null) ||
          item.stopWS
        )
      },
      endControl: function () {
        const item = this.form
        const current = { ...this.currentRow }
        return (
          (current.stopWS && !item.stopWS) ||
          (!current.stopWS && current.stopEnd !== null)
        )
      },
    },
    data() {
      const currentRow = { ...this.currentRow }
      currentRow.stopStart = dayjs(currentRow.stopStart)
      currentRow.stopEnd = dayjs(currentRow.stopEnd)

      return {
        spinning: false,
        form: { ...currentRow },
      }
    },
    methods: {
      disabledDate: (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf('day')
      },
      disabledDateTime: (current) => {
        const range = (start, end) => {
          const result = []

          for (let i = start; i < end; i++) {
            result.push(i)
          }
          return result
        }
        const curH = dayjs().hour()
        const curM = dayjs().minute()
        // 选中日期是否与当前日期相同
        const isSameDate = dayjs().isSame(current, 'date')
        // 选择时间是否与当前时间相同
        const isSameHour = dayjs().isSame(current, 'hour')
        return {
          disabledHours: () => (isSameDate ? range(curH + 1, 24) : []),
          disabledMinutes: () =>
            isSameDate && isSameHour ? range(curM + 1, 60) : [],
        }
      },
      submit(type) {
        const {
          adnId,
          andonType,
          comments,
          jobId,
          objectId,
          createBy,
          regionCode,
          stopStart,
          stopEnd,
          stopWS,
          createOn,
          closeBy,
          closeOn,
        } = this.form
        const raw = {
          adnId,
          andonType,
          comments,
          jobId,
          objectId,
          person: createBy,
          regionCode,
          status: 'responsed',
          stopStart: stopStart ? dayjs(stopStart).valueOf() : null,
          stopEnd: stopEnd ? dayjs(stopEnd).valueOf() : null,
          stopWorking: stopWS,
          createTime: createOn,
          closeBy,
          closeOn,
        }
        this.spinning = true
        if (type === 1) {
          // response andon
          responseandon(raw)
            .then((res) => {
              if (res.body.status === 0) {
                Modal.error({
                  title: () => res.body.msg,
                })
              } else {
                this.$emit('responseSuccess')
              }
            })
            .finally(() => {
              this.spinning = false
            })
        } else {
          // close andon
          if (this.form.stopWS) {
            message.warning('关闭stop working后才可以关闭andon')
            return
          }
          closeAndon(raw)
            .then((res) => {
              if (res.body.status === 0) {
                Modal.error({
                  title: () => res.body.msg,
                })
              } else {
                this.$emit('responseSuccess')
              }
            })
            .finally(() => {
              this.spinning = false
            })
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  .m-label {
    padding-bottom: 10px;
  }
</style>
